export function Step2({ className }: { className?: string }) {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="96" height="96" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 14C27 11.2386 29.2386 9 32 9H40H42H54H56H64C66.7614 9 69 11.2386 69 14V30H67V14C67 12.3431 65.6569 11 64 11H56V13C56 14.1046 55.1046 15 54 15H42C40.8954 15 40 14.1046 40 13V11H32C30.3431 11 29 12.3431 29 14V74.8621V82C29 83.6569 30.3431 85 32 85H64C65.6569 85 67 83.6569 67 82V74.8621V66.5H69V74.8621V82C69 84.7614 66.7614 87 64 87H32C29.2386 87 27 84.7614 27 82V74.8621V14ZM42 11V13H54V11H42ZM41 82C41 81.4477 41.4477 81 42 81H53C53.5523 81 54 81.4477 54 82C54 82.5523 53.5523 83 53 83H42C41.4477 83 41 82.5523 41 82Z"
        fill="black"
      />
      <path
        d="M74 55.9998H62C61.4696 55.9998 60.9609 55.7891 60.5858 55.414C60.2107 55.0389 60 54.5302 60 53.9998V50.9998H62V53.9998H74V50.9998H76V53.9998C76 54.5302 75.7893 55.0389 75.4142 55.414C75.0391 55.7891 74.5304 55.9998 74 55.9998Z"
        fill="#656BBB"
      />
      <path d="M82 46.9998H54V48.9998H82V46.9998Z" fill="#656BBB" />
      <path
        d="M76 44.9998H74V41.9998H62V44.9998H60V41.9998C60 41.4694 60.2107 40.9607 60.5858 40.5856C60.9609 40.2105 61.4696 39.9998 62 39.9998H74C74.5304 39.9998 75.0391 40.2105 75.4142 40.5856C75.7893 40.9607 76 41.4694 76 41.9998V44.9998Z"
        fill="#656BBB"
      />
      <path d="M82 42H80V36H74V34H82V42Z" fill="#656BBB" />
      <path d="M56 42H54V34H62V36H56V42Z" fill="#656BBB" />
      <path d="M62 62H54V54H56V60H62V62Z" fill="#656BBB" />
      <path d="M82 62H74V60H80V54H82V62Z" fill="#656BBB" />
    </svg>
  );
}
